// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"b0b2319e","453":"5539f527"}[chunkId] + ".chunk.js";
};